<template>
  <div>
    <!-- 内容列表对话框 -->
    <el-dialog title="卡片选择" :visible.sync="dialogVisible" :modal-append-to-body="true" append-to-body
      close-on-click-modal width="40%" @closed="handleClose">
      <div class="search-flex">
        <div>
          <el-input size="small" clearable v-model="searchParams.name" placeholder="卡片名称"
            style="width: 200px; margin-right: 10px"></el-input>
          <!-- select选择状态 0失效 1生效 2待生效-->
          <el-select size="small" v-model="searchParams.status" placeholder="状态" style="width: 200px">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <el-button type="primary" size="small" @click="search">搜索</el-button>
      </div>
      <el-table ref="multipleTable" :data="list" tooltip-effect="dark" style="margin-top: 20px" row-key="id"
        @select="selectionChange" @select-all="selectAll">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="ID" prop="id" width="55"> </el-table-column>
        <el-table-column label="卡片名称" prop="name"> </el-table-column>
        <el-table-column label="	卡片类型" prop="type">
          <!-- （1：焦点卡片；2：专题卡片；3：导航卡片 4: 榜单卡片 5：追剧投屏卡片；6：内容卡片；7：内容横滑卡片；8：直播卡片 9：导航横滑卡片 10：焦点组卡片） -->
          <template slot-scope="{ row }">
            <span v-if="row.type === 1">焦点卡片</span>
            <span v-else-if="row.type === 2">专题卡片</span>
            <span v-else-if="row.type === 3">导航卡片</span>
            <span v-else-if="row.type === 4">榜单卡片</span>
            <span v-else-if="row.type === 5">追剧投屏卡片</span>
            <span v-else-if="row.type === 6">内容卡片</span>
            <span v-else-if="row.type === 7">内容横滑卡片</span>
            <span v-else-if="row.type === 8">直播卡片</span>
            <span v-else-if="row.type === 9">导航横滑卡片</span>
            <span v-else-if="row.type === 10">焦点组卡片</span>
          </template>
        </el-table-column>
        <el-table-column label="卡片标题" prop="title"> </el-table-column>
        <el-table-column label="状态" prop="status" width="80">
          <template slot-scope="{ row }">
            <span v-if="row.status === 1">生效</span>
            <span v-else-if="row.status === 0">失效</span>
            <span v-else-if="row.status === 2">待生效</span>
          </template>
        </el-table-column>
        <!-- todo: 生效时间 -->
        <el-table-column label="生效时间" prop="effectStartTime">
          <template slot-scope="{ row }">
            <span v-if="row.effectStartTime">
              {{ row.effectStartTime }} 至 {{ row.effectEndTime }}
            </span>
            <span v-else> - </span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <ElementPagination style="margin-bottom: 20px" :current-page="searchParams.current" :page-size="searchParams.size"
        :total="searchParams.total" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
      <!-- 保存和取消 -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="hide">取 消</el-button>
        <el-button type="primary" size="small" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAppCardList } from "@/api/apps/pageStrategy";
import ElementPagination from "@/components/ElementPagination";
import Message from "@/components/Message";
export default {
  name: "WebSaaSMultipleCards",
  components: {
    ElementPagination,
  },
  data() {
    return {
      /** 对话框是否可见 */
      dialogVisible: false,
      /** 搜索参数 */
      searchParams: {
        current: 1,
        size: 10,
        total: 0,
        name: "",
        status: "",
      },
      list: [],
      /** 选中的ids */
      selectIds: [],
      /** 选中的数据 */
      selectItems: [],
      /** 状态选项 */
      statusOptions: [
        { label: "待生效", value: 2 },
        { label: "生效", value: 1 },
        { label: "失效", value: 0 },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 保存的事件 */
    save() {
      console.log("save", this.selectIds);
      const res = [...this.selectItems];

      console.log("res", res);
      this.$emit("save", res);
      this.hide();
    },
    /** 选择的事件 */
    selectionChange(val, row) {
      console.log(this.selectIds);
      console.log("", val, row);
      /** 判断id是否在selectIds中 */
      const index = this.selectIds.findIndex((id) => id === row.id);
      if (index !== -1) {
        // 如果存在，就删除
        this.selectIds.splice(index, 1);
        const itemIndex = this.selectItems.findIndex(
          (item) => item.id === row.id
        );
        if (itemIndex !== -1) {
          this.selectItems.splice(itemIndex, 1);
        }
      } else {
        // 如果不存在，就添加
        this.selectIds.push(row.id);
        this.selectItems.push(row);
      }
    },
    /** 全选的事件 */
    selectAll(val) {
      console.log("全选的事件", val);
      if (val) {
        this.selectIds = [];
        val.forEach((item) => {
          this.selectIds.push(item.id);
        });
        this.selectItems = [];
        val.forEach((item) => {
          this.selectItems.push(item);
        });
      } else {
        this.selectIds = [];
        this.selectItems = [];
      }
    },
    show(row) {
      console.log("show", row);
      if (row) {
        row.forEach((item) => {
          this.selectIds.push(item.id);
          this.selectItems.push(item);
        });
      }
      console.log("this.selectIds", this.selectIds);

      this.getList();
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
      this.selectIds = [];
      this.selectItems = [];
    },
    //^ ^--------------分页相关-------------^ ^
    /** 搜索 */
    async search() {
      this.searchParams.current = 1;
      /** 更新数据 */
      this.getList();
      Message.success("搜索成功");
    },
    /** 分页 */
    async getList() {
      console.log("getList");
      /** 请求数据 */
      const { data } = await getAppCardList(this.searchParams);
      console.log("分页的响应", data);
      this.list = data.data.records;
      this.searchParams.total = data.data.total;
      /** 回填选中态 */
      this.$nextTick(() => {
        this.list.forEach((item) => {
          if (this.selectIds.includes(item.id)) {
            console.log("回填选中态", item);
            this.$refs.multipleTable.toggleRowSelection(item, true);
          }
        });
      });
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.getList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
